export default __webpack_public_path__ + "static/media/filtrof.5e3fda6b.jpg";